import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaEnvelope, FaLinkedin } from 'react-icons/fa';
import './Team.css';

const Team = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  const team = [
    {
      name: 'Yash Khare',
      role: 'Co-Founder & AI Specialist',
      email: 'yashco.ltd@gmail.com',
      linkedin: 'https://www.linkedin.com/in/yash-khare-8b571028a/',
      color: '#667eea'
    },
    {
      name: 'Puja Rachchh',
      role: 'Co-Founder & Automation Expert',
      email: 'pujarachchh@gmail.com',
      linkedin: 'https://www.linkedin.com/in/puja-rachchh/',
      color: '#764ba2'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const cardVariants = {
    hidden: { y: 100, opacity: 0, rotateX: -20 },
    visible: {
      y: 0,
      opacity: 1,
      rotateX: 0,
      transition: {
        type: 'spring',
        stiffness: 80,
        damping: 15
      }
    }
  };

  return (
    <section id="team" className="section team" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: -50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>Meet Our Team</h2>
          <p>The visionaries behind your AI transformation</p>
        </motion.div>

        <motion.div
          className="team-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {team.map((member, index) => (
            <motion.div
              key={index}
              className="team-card glass"
              variants={cardVariants}
              whileHover={{
                y: -15,
                rotateY: 5,
                transition: { duration: 0.3 }
              }}
              style={{ perspective: 1000 }}
            >
              <motion.div
                className="member-avatar"
                style={{ background: `linear-gradient(135deg, ${member.color} 0%, #764ba2 100%)` }}
                whileHover={{ scale: 1.1, rotate: 5 }}
                transition={{ duration: 0.3 }}
              >
                <div className="avatar-text">{member.name.split(' ').map(n => n[0]).join('')}</div>
                <div className="avatar-glow"></div>
              </motion.div>

              <h3>{member.name}</h3>
              <p className="role">{member.role}</p>

              <div className="social-links">
                <motion.a
                  href={`mailto:${member.email}`}
                  className="social-link"
                  whileHover={{ scale: 1.2, rotate: 10 }}
                  whileTap={{ scale: 0.9 }}
                  title="Email"
                >
                  <FaEnvelope />
                </motion.a>
                <motion.a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  whileHover={{ scale: 1.2, rotate: -10 }}
                  whileTap={{ scale: 0.9 }}
                  title="LinkedIn"
                >
                  <FaLinkedin />
                </motion.a>
              </div>

              <div className="card-shine"></div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Team;
